import { render, staticRenderFns } from "./AppNoDataImage.vue?vue&type=template&id=24e8c893&scoped=true&"
import script from "./AppNoDataImage.vue?vue&type=script&lang=js&"
export * from "./AppNoDataImage.vue?vue&type=script&lang=js&"
import style0 from "./AppNoDataImage.vue?vue&type=style&index=0&id=24e8c893&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e8c893",
  null
  
)

export default component.exports